export * from '@primeuix/themes/aura/inputchips';
export { default } from '@primeuix/themes/aura/inputchips';
